import common from './common';

const languageService = {
  ...common('languages')
};
export { languageService };
